// Module
import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

// CSS
import '_Asset/css/User/Page/connect.css';

// Component
import { PostList } from "User/Component";
import { useRef } from "react";

// API
import { NewsListApi } from "_Route/Api";


const NewsDt = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const sanitizer = dompurify.sanitize;
  const params = useParams();
  const postGroupRef = useRef(null);
  
  const [newsData, setNewsData] = useState([]);
  let heightArr = [];
  
  useEffect(() => {
    axios.get(NewsListApi)
    .then(res => {
      setNewsData(res.data.result)
    })
    .catch(err => {
      console.error(err, "ERROR...")
    })
  }, [])

  const detailItem = newsData.find(key => key.news_uuid == params.id)


  // Prev, Next Button Event
  const itemIdx = newsData.findIndex(key => key.news_uuid == params.id);

  const prevBtn = () => {
    if (itemIdx === 0) {
      navigate(`/connect/news`);
    } else {
      navigate(`/connect/news/list/${newsData[itemIdx - 1].news_uuid}`);
    }
  }

  const nextBtn = () => {
    navigate(`/connect/news/list/${newsData[itemIdx + 1].news_uuid}`);
  }

  const recentNum = 3;
  const recentPost = newsData.filter((key, i) => i < recentNum)

  const FormatConv = (date) => {
    const newDate = new Date(date);

    const month = newDate.toLocaleString("en-US", { month: "long" })
    const dt = newDate.getDate();
    const year = newDate.getFullYear();

    return (month + ' ' + dt + ', ' + year)
  }

  // JSON Parse Error Exception Handling
  const onTag = (data) => {
    try {
      const parseData = JSON.parse(data)
      return parseData === null || parseData === undefined ? [] : parseData;
    }
    catch (err) {
      return []
    }
  }


  return (
    <>
      {/* Visual */}
      <div className="visual connect">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">News</h2>
            
            <p className="visualTxt">Seyfert Developers News and Updates.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        {
          newsData.length !== 0 &&
          <div className="section">
            <div className="detailArea areaBox">
              <div className="titGroup">
                <div className="category">
                  <p>{detailItem.news_cat}</p>

                  <div className="tagGroup">
                    {onTag(detailItem.news_tag).map((tag, i) =>
                      <span key={i}>{tag.substring(0, 1) === '#' ? tag : '#' + tag}</span>
                    )}
                  </div>
                </div>

                <h2 className="detailTit">{detailItem.news_title}</h2>

                <div className="registInfo">
                  <p>작성자: {detailItem.news_author}</p>
                  <span>게시일: {FormatConv(detailItem.news_fd)}</span>
                </div>
              </div>

              <div className="contGroup">
                <span dangerouslySetInnerHTML={{ __html: sanitizer(detailItem.news_content) }}></span>
                {
                  detailItem.fileName &&
                  <div className="downloadTxt">
                    <i className="icofont-link"></i>
                    <span>{detailItem.news_file}</span>
                  </div>
                }
              </div>

              <div className="navBtn">
                <button type="button" className="btn sm black_edge i_lt round_10" onClick={() => prevBtn()}><i className="icofont-rounded-left"></i>{itemIdx === 0 ? 'Back to List' : 'Prev'}</button>
                {
                  itemIdx + 1 !== newsData.length &&
                  <button type="button" className="btn sm black_edge i_rt round_10" onClick={() => nextBtn()}>Next<i className="icofont-rounded-right"></i></button>
                }
              </div>
            </div>
          </div>
        }

        {/* Recent Posts */}
        {/* <div className="section">
          <div className="recentArea areaBox">
            <div className="contTitGroup">
              <div className="contTitRow">
                <h2 className="contTit">Recent Posts</h2>
              </div>

              <p className="contMsg">Find in-technical content written by developers</p>
            </div>

            <div className="postGroup" ref={postGroupRef}>
              {recentPost.map((key, i) =>
                <PostList item={key} index={i} key={i} heightArr={heightArr} type='news' ref={postGroupRef} />
              )}
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default NewsDt;